/**
 * Supabase password recovery: redirectTo must exactly match an allow-listed URL
 * (Dashboard → Authentication → URL Configuration → Redirect URLs).
 *
 * Set REACT_APP_AUTH_REDIRECT_BASE when the SPA is opened from a URL that is NOT
 * on that list (e.g. preview deploy) but emails should use your production app URL.
 */
export function getPasswordResetRedirectTo(): string {
  const envBase = (process.env.REACT_APP_AUTH_REDIRECT_BASE || '').trim().replace(/\/$/, '');
  if (envBase) {
    return `${envBase}/auth`;
  }
  if (typeof window !== 'undefined' && window.location?.origin) {
    return `${window.location.origin}/auth`;
  }
  return '';
}

/** True when the browser bundle talks to local Supabase (emails go to Inbucket, not real inbox). */
export function isLikelyLocalSupabaseUrl(): boolean {
  const u = (process.env.REACT_APP_SUPABASE_URL || '').toLowerCase();
  return (
    u.includes('127.0.0.1') ||
    u.includes('localhost') ||
    u.includes('host.docker.internal') ||
    u.includes('kong:8000')
  );
}
